/**
 * Lab Document Format Service
 * Handles CRUD, calibration, and detection for lab document formats
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { LAB_DOCUMENT_FORMAT_ENDPOINTS } from '../endpoints';

const labDocumentFormatService = {
  getAll: async () => {
    return apiRequest(() =>
      axiosInstance.get(LAB_DOCUMENT_FORMAT_ENDPOINTS.LIST)
    );
  },

  getById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(LAB_DOCUMENT_FORMAT_ENDPOINTS.GET_BY_ID(id))
    );
  },

  create: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(LAB_DOCUMENT_FORMAT_ENDPOINTS.CREATE, data)
    );
  },

  update: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(LAB_DOCUMENT_FORMAT_ENDPOINTS.UPDATE(id), data)
    );
  },

  delete: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(LAB_DOCUMENT_FORMAT_ENDPOINTS.DELETE(id))
    );
  },

  getUploadUrl: async (fileName, fileSizeBytes) => {
    return apiRequest(() =>
      axiosInstance.get(LAB_DOCUMENT_FORMAT_ENDPOINTS.UPLOAD_URL, {
        params: { fileName, fileSizeBytes },
      })
    );
  },

  calibrate: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(LAB_DOCUMENT_FORMAT_ENDPOINTS.CALIBRATE, data, {
        timeout: 600000, // 10 minutes — large documents: Textract + parallel AI passes
      })
    );
  },

  detect: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(LAB_DOCUMENT_FORMAT_ENDPOINTS.DETECT, data, {
        timeout: 120000, // 2 minutes
      })
    );
  },
};

export default labDocumentFormatService;
